import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import StickyHeader from '~/modules/common/components/StickyHeader/StickyHeader';
import { useStickyHeaderStyles } from './ResourcingOverviewToolbar';

const useStyles = makeStyles(theme => ({
  spacer: {
    flexGrow: 1,
    flexShrink: 1
  },
  periodSelector: {
    width: 300,
    marginLeft: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1),
      width: 240
    }
  },
  periodDropdown: {
    width: 80,
    marginRight: theme.spacing(2)
  }
}));

const ResourcingOverviewToolbarSkeleton = () => {
  const classes = useStyles();
  const stickyHeaderStyles = useStickyHeaderStyles();

  return (
    <StickyHeader level={2} classes={stickyHeaderStyles}>
      <Skeleton variant="rect" className={classes.periodSelector} height={32} />
      <div className={classes.spacer} />
      <Skeleton variant="rect" className={classes.periodDropdown} height={32} />
    </StickyHeader>
  );
};

export default ResourcingOverviewToolbarSkeleton;
